import * as React from 'react';
import * as Glob from '../Globale';
import * as Compat from '../Compat';
import { BasePureComponent } from './BaseComponent';
import * as Dati from '../Dati';
import { Trad, CampoPassword } from '../components/';
import { Dictionary } from '../Dati';


interface IInputPasswordProps extends Dati.IBaseProps {
    Etichetta: string;
    Valore: string;
    Placeholder?: string;
    Required?: boolean;
    AutoComplete?: string;
}

export class InputPassword extends BasePureComponent<IInputPasswordProps, {}> {
    constructor(props: any) {
        super(props);
    }

    public render() {
        let etichetta: any = "";
        if (typeof (this.props.Etichetta == "string")) {
            etichetta = <label>{Trad.Trad(this.props.Etichetta)}</label>;
        } else {
            etichetta = this.props.Etichetta;
        }
        return <div style={{ minHeight: 88 }} className={this.props.CSS != undefined ? this.props.CSS : ""}>
            {etichetta}
            <CampoPassword Name={this.props.Name} Id={this.props.Id} OnChange={this.OnChange} Valore={this.props.Valore} DimensioneCSS={12} />
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/InputPassword.tsx